export default function categoryName(number) {
    let categoryName;
  
    switch(parseInt(number)) {
        case 1:
            categoryName = 'Antiques';
            break;
          case 2:
            categoryName = 'Appliances';
            break;
          case 3:
            categoryName = 'Art';
            break;
          case 4:
            categoryName = 'Baby & Kids';
            break;
          case 5:
            categoryName = 'Books';
            break;
          case 6:
            categoryName = 'Cell Phones';
            break;
          case 7:
            categoryName = 'Clothing';
            break;
          case 8:
            categoryName = 'Collectibles';
            break;
          case 9:
            categoryName = 'Computers';
            break;
          case 10:
            categoryName = 'Crafts';
            break;
          case 11:
            categoryName = 'Electronics';
            break;
          case 12:
            categoryName = 'Furniture';
            break;
          case 13:
            categoryName = 'Games & Toys';
            break;
          case 14:
            categoryName = 'Health & Beauty';
            break;
          case 15:
            categoryName = 'Hobbies';
            break;
          case 16:
            categoryName = 'Home & Garden';
            break;
          case 17:
            categoryName = 'Jewelry';
            break;
          case 18:
            categoryName = 'Kitchenware';
            break;
          case 19:
            categoryName = 'Musical Instruments';
            break;
          case 20:
            categoryName = 'Music';
            break;
          case 21:
            categoryName = 'Office Supplies';
            break;
          case 22:
            categoryName = 'Outdoor Gear';
            break;
          case 23:
            categoryName = 'Pet Supplies';
            break;
          case 24:
            categoryName = 'Photography';
            break;
          case 25:
            categoryName = 'Sporting Equipment';
            break;
          case 26:
            categoryName = 'Sporting Goods';
            break;
          case 27:
            categoryName = 'Tools';
            break;
          case 28:
            categoryName = 'Cars & Trucks';
            break;
          case 29:
            categoryName = 'Video Games';
            break;
          case 30:
            categoryName = 'Vintage Items';
            break;
          case 31:
            categoryName = 'Car Parts';
            break;
          case 32:
            categoryName = 'Miscellaneous';
            break;
          case 33:
            categoryName = 'Other';
            break;
          default:
            categoryName = 'Other Category';
            break;
    }
  
    return categoryName;
  }